export default "__VITE_ASSET__CU$iryOK__"